import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export function AiSuggestButton({ endpoint, body, onText, label = "AI suggest", testId, disabled, hint }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (disabled) { toast.error(hint || "Fill in the details first"); return; }
    setBusy(true);
    try { const { data } = await api.post(endpoint, typeof body === "function" ? body() : body); onText(data.text); toast.success("AI suggestion added – review and edit as you like"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={run} disabled={busy} data-testid={testId}
      className="group inline-flex items-center gap-1.5 rounded-full border border-[#2412B5]/30 bg-gradient-to-r from-[#2412B5]/10 to-[#086477]/10 px-3 py-1 text-xs font-semibold text-[#2412B5] transition-transform hover:scale-[1.03] disabled:opacity-60">
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5 transition-transform group-hover:rotate-12" />}{busy ? "Writing…" : label}
    </button>
  );
}
